import './SaveProduct.css';

export default () => {
  $('.adding-to-cart').click(function(event) {
    /* Act on the event */
    event.preventDefault();
    event.stopPropagation();
  });

  $(document).on('click', '[data-save-product]', function(event) {
    console.log( $(this) );

    var clicked_el = $(this);

    var current_saved_products = getCookie('saved-products');
    var row_id = $(this).data('row-id');
    var img =  $('[data-img-id=' + row_id + ']');

    $('[data-fixed-remove-from-cart]').data('row-id', row_id );

    console.log( $(this).data('product-name') );
    console.log( img.attr('src') );

    var posX = $(this)[0].getBoundingClientRect().left + ( $(this).width() / 2 ) ,
    posY = $(this)[0].getBoundingClientRect().top + ( $(this).height() / 2 );

    console.log( posX );
    console.log( posY );

    var bezier_params = {
        start: {
          x: posX,
          y: posY,
          angle: -30
        },
        end: {
          x: $(window).width() - 135,
          y: ( $('.add-to-cart-wrapper').hasClass('slide-up') ? $(window).height() - $('.add-to-cart-wrapper').height() : $(window).height() ),
          angle: 40,
          length: 0.25,
          opacity: 0
        }
      }

    $('[data-row-id="' + $(this).data('row-id') + '"] .adding-to-cart').toggleClass('shown');


    if( ! clicked_el.hasClass('added-to-list') ){

      $('.cart-animation-element').css({
        top: posY,
        left: posX,
        opacity: 1
      });

      setTimeout(
        function(){
          $('.cart-animation-element').show();
          $('.cart-animation-element').addClass('grow');
          $('.cart-animation-element').animate(
            {
                path : new $.path.bezier(bezier_params)
            },
            750, function(){
              $('[data-cart-text]').text(clicked_el.data('product-name'));

              if( img ){
                $('[data-cart-img]').attr( 'src', img.attr('src') );
              }
              console.log( clicked_el );
              $('[data-add-to-cart-wrapper]').addClass('slide-up');
              $('.cart-animation-element').removeClass('grow');
              $('.cart-animation-element').hide();
              console.log( clicked_el.find('.adding-to-cart') );
              clicked_el.find('.adding-to-cart').removeClass('shown');
              if( $(window).width() > 660 ){
                // setTimeout(
                //   function(){
                //     $('[data-add-to-cart-wrapper]').removeClass('slide-up');
                //   },
                //   3000
                // );
              }
            }
          );
        },
        5
      );
    } else {
      $('[data-row-id="' + clicked_el.data('row-id') + '"] .adding-to-cart').removeClass('shown');
    }


    if( current_saved_products ){
      // console.log( 'Index of product: ' + current_saved_products.indexOf(row_id) );
      if( current_saved_products.indexOf(row_id) !== -1 ){
        var new_saved_products = current_saved_products.replace(row_id, '');

        // console.log( new_saved_products.charAt(new_saved_products.length - 1) );
        if( new_saved_products.charAt(new_saved_products.length - 1) === '|' ){
          new_saved_products = new_saved_products.substring(0, new_saved_products.length - 1);
        }

        // console.log( new_saved_products.charAt(0) );
        if( new_saved_products.charAt(0) === '|' ){
          new_saved_products = new_saved_products.substring(1, new_saved_products.length);
        }
        new_saved_products = new_saved_products.replace('||', '|');
        // console.log( new_saved_products );
        setCookie('saved-products', new_saved_products, '7');
      } else {
        setCookie('saved-products', current_saved_products + '|' + row_id , '7');
      }
    } else {
      setCookie('saved-products', row_id , '7');
    }
    // console.log( $('[data-row-id="' + $(this).data('row-id') + '"]') );
    $('[data-row-id="' + $(this).data('row-id') + '"]').toggleClass('added-to-list');
    if( $(this).parent().hasClass('individual-product') ){
      $(this).parent().remove();
      generate_saved_product_html();
    }
    // console.log( row_id );
    // console.log( 'Cookie saved-products: ' + getCookie('saved-products') );
    intial_toggle_of_saved_products();
  });

  $('[data-close-overlay], [data-fixed-remove-from-cart]').click(function(event) {
    /* Act on the event */
    event.preventDefault();
    $('[data-add-to-cart-wrapper]').removeClass('slide-up');
  });

  function intial_toggle_of_saved_products(){
    var current_saved_products = getCookie('saved-products');
    $.each($('[data-save-product]'), function(index, el) {
      if( current_saved_products.indexOf($(this).data('row-id')) !== -1 ){
        $(this).addClass('added-to-list');
      }
    });

    if( current_saved_products ){
      var saved_products_count = current_saved_products.split("|").length;
      $('[data-samples-count-desktop] span, .data-over-menu-products span').text('(' + saved_products_count + ')')
      $('[data-add-to-cart-wrapper]').removeClass('fully-hidden');
    } else {
      $('[data-samples-count-desktop] span, .data-over-menu-products span').text('(0)');
      $('[data-add-to-cart-wrapper]').addClass('fully-hidden');
      $('[data-add-to-cart-wrapper]').removeClass('slide-up');
    }
  }

  intial_toggle_of_saved_products();
  generate_saved_product_html();

  function generate_saved_product_html(){
    if( ! $('[data-my-products]').length ){
      return;
    }
    $.ajax({
        url: '/wp-json/saved-products/v1/posts/',
        type: 'POST',
        data: {saved_products: getCookie('saved-products')}
      })
      .done(function(data) {
        console.log( data );
        console.log( data.html );
        if( data.html ){
          $('[data-my-products]').html(data.html);
        } else {
          $('[data-my-products]').html('<h3>No products currently on your list.</h3>');
        }
        if( $('[data-continue-with-no-products]').length ){
          var gform_next_btn = $('#gform_next_button_2_2').clone(true).attr('value', 'Continue');
          $('[data-continue-with-no-products]').replaceWith(gform_next_btn);
        }
        // if( $('[data-span-continue-with-no-products]').length ){
        //   var gform_next_btn = $('#gform_next_button_2_2').clone(true).attr('value', 'Continue');
        //   $('[data-span-continue-with-no-products]').replaceWith(gform_next_btn);
        // }
        if( shared_list ){
          $('body').find('[data-save-product]').hide();
        }
        // if( $('[name="input_36"]').val() === '' ){
        $('[name="input_36"]').val( $('[name="general-products"]').val());

        const productList = document.querySelectorAll('.individual-product');
        if(productList.length > 0) {
          productList.forEach(item => {
            const headings = item.querySelectorAll('p.heading');
            if(headings.length > 0) {
              $('[name="input_36"]').val( $('[name="input_36"]').val(  ) +headings[1].textContent.toUpperCase()+'\r\n'+headings[0].textContent+". \r\n\r\n" );
            }
          });
        }
        
        const gformForm = document.querySelector('.my-product-list-page form');
        const gformSubmitBtn = document.querySelector('.my-product-list-page input[type="submit"]');
        if( document.querySelectorAll('[data-table-row-id]').length === 0 ) {
          if( gformSubmitBtn ) {
            // Disable form submit
            gformForm.setAttribute("onSubmit", "event.preventDefault();");
            // Disable submit button
            gformSubmitBtn.classList.add('save-disabled');
          }
        }
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        console.log("error");
        console.log('jqXHR');
        console.log(jqXHR);
        console.log('textStatus');
        console.log(textStatus);
        console.log('errorThrown');
        console.log(errorThrown);
      })
      .always(function() {
        console.log("complete");
      });

  }


  $('body').on("change", '[name="general-products"]', function(event) {
    $('[name="input_36"]').val( $('[name="general-products"]').val());
  });
}